export enum AdminView {
  Integrations = "Integrations",
  Tools = "Tools",
  Surveys = "Surveys",
  Users = "Users",
  Accounts = "Accounts"
}
